<div class="app-content">
  <div id="nav-header">
    <dx-resizable class="resizable-container" handles="right" area=".widget-container">
      <div class="top-bar">
        <div class="heading-image">
          <img alt="logo" src="../../assets/icons/niclen_logo.png" />
        </div>

        <dx-menu
          class="nav-header"
          data-e2eid="main-navigation-menu"
          [items]="menuItems"
          displayExpr="text"
          (onItemClick)="onMenuItemClick($event)"
          (onItemRendered)="onMenuItemRendered($event)">
        </dx-menu>
      </div>
    </dx-resizable>
  </div>

  <hr />

  <div id="layout-container">
    <div id="left-col">
      <router-outlet></router-outlet>
    </div>
    <div id="right-col">
      <router-outlet name="right"></router-outlet>
    </div>
  </div>

  <div class="footer"></div>
</div>
